import { AutocompleteOption } from '@types'

export const isAutocompleteOption = (value: unknown): value is AutocompleteOption => {
  return typeof value === 'object' && value !== null && 'id' in value && 'label' in value
}
